import React, { Component } from 'react';
import MainStore from '../../../MainStore';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import MaterialTable from '@material-table/core';

export default class EnvironmentProductTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: []
        };

        this.columns = [
            { field: 'productName', title: 'Продукт', width: 200 },
            { field: 'version', title: 'Версия', width: 150 }
         ];

        this.load = this.load.bind(this);
        this.openAddEnvironmentProductDialog = this.openAddEnvironmentProductDialog.bind(this);
        this.editEnvironment = this.editEnvironment.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.environmentId !== this.props.environmentId) {
            this.load();
        }
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Environment/GetEnvironmentProducts?environmentId=' + this.props.environmentId,
            null
            ,
            'application/json',
            (result) => {
                scope.setState({ products: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    }

    openAddEnvironmentProductDialog() {
        MainStore.openEnvironmentProductDialog({ id: '', standId: this.props.environmentId}, this.load);
    }

    editEnvironment(product) {
        MainStore.openEnvironmentProductDialog(product, this.load);
    }

    deleteProduct(product, resolve) {
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Environment/DeleteEnvironmentProduct',
            JSON.stringify(product)
            ,
            'application/json',
            (result) => {
                var products = this.state.products.slice(0);
                var index = products.findIndex(e => e.id === product.id);
                if (index !== -1) products.splice(index, 1);
                this.setState({ products: products });
                MainStore.setMaskUnvisible();
                resolve();
            },
            'POST'
        );
    }

    render() {
        if (!this.props) {
            return <div></div>
        }

        return (
            <div>
                <div style={{ height: '550px', width: '100%' }}>
                    <MaterialTable
                        title=""
                        columns={this.columns}
                        data={this.state.products}
                        editable={{
                            onRowDelete: oldData =>
                                new Promise(resolve => {
                                    this.deleteProduct(oldData, resolve);
                                }),
                        }}
                        actions={[
                            {
                                icon: 'add',
                                tooltip: 'Добавить среду',
                                isFreeAction: true,
                                onClick: this.openAddEnvironmentProductDialog
                            },
                            {
                                icon: 'edit',
                                tooltip: 'Редактировать',
                                isFreeAction: false,
                                onClick: (event, rowData) => {
                                    this.editEnvironment(rowData);
                                }
                            }
                        ]}
                        options={{
                            actionsColumnIndex: -1
                        }}
                    />
                </div>
            </div>
        );
    }
}
